import { AxiosBookings } from "../apiConfig";

export const domainsApiFactory = {
  $_getAllDomains() {
    let url = "/domains/find-user-subdomains";
    return AxiosBookings.get(url);
  },
  $_createDomain(payload) {
    const url = `/domains`;
    return AxiosBookings.post(url, payload);
  },
  $_deleteDomain(email) {
    const url = `/domains/remove-subdomain?email=${email}`;
    return AxiosBookings.delete(url);
  },
  $_updateDomain(payload) {
    const url = `/domains/update-subdomain`;
    return AxiosBookings.patch(url, payload);
  },
  $_setDefaultDomain(locationId) {
    const url = `/domains/setdefault/${locationId}`;
    // const userId = localStorage.getItem("userId");
    // const payload = {
    //   userId: userId,
    // };
    return AxiosBookings.patch(url);
  },
};
